module.exports = __webpack_public_path__ + "static/media/close-icon.2c15e941.svg";